import React from "react";
import Articles from "../components/Article/Articles";
import Faqs from "../components/Faq/Faqs";
import Messages from "../components/Messages/Messages";
import "../components/Messages/Messages.css";
import Flowchart from "../components/Flowchart/Flowchart";
import Footer from "../components/Footer/Footer";
import Icon from "../components/Icons/Icon";
import Links from "../components/Links/Links";
import dataServices from "../common/dataServices";
import Aux from './../hoc/Aux';


class ModWebParts extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        items: [],
       // webpartType:'',
        WpId:'',
        webpartLayout:'',
    };
    
    
    GetListItems(){

        const listName = this.props.webPartProperties.listName;  
        const viewName =this.props.webPartProperties.listView; 
        const siteUrl = this.props.webPartProperties.site; 
        dataServices.getSPListItems(siteUrl,listName,viewName)
        .then((response)=> response.data)   
        .then(lsItemsResponse=>{
            var itemsData = JSON.parse(lsItemsResponse);
            this.setState(
                {
                    items: itemsData,
                   // webpartType: this.props.webPartProperties.type,
                    webpartTitle: this.props.webPartProperties.title,
                    WpId:this.props.webPartProperties.WpId,
                    webpartLayout:this.props.webPartProperties.layout
                }
            )
            
        })
    }

    componentDidMount() {  
        this.GetListItems();
     }
    render() {
        let selectedWP="";
        let wpClass ='';
        let wrap='';
        if(this.props.webPartProperties.type =='Article'){
            // selectedWP = this.state.items.map((item,index) => (
            //     <Article data={item}/>
            // )) 
            selectedWP = <Articles items={this.state.items}/>
        }
        else if(this.props.webPartProperties.type =='Faq'){
            selectedWP =  <Faqs items={this.state.items} wpId={this.state.WpId}/>
        }
        else if(this.props.webPartProperties.type =='Flowchart'){
            selectedWP = this.state.items.map((item,index) => (
                <Flowchart data={item}/>
            )) 
        }
        else if(this.props.webPartProperties.type =='Footer'){
            selectedWP = this.state.items.map((item,index) => (
                <Footer data={item} key={"Footer_"+index}/>
            )) 
        }
        else if(this.props.webPartProperties.type =='Messages'){
            selectedWP = //this.state.items.map((item,index) => (
                <Messages items={this.state.items}/>
           // )) 
        }
        else if(this.props.webPartProperties.type =='Icons'){
            selectedWP = this.state.items.map((item,index) => (
                <Icon data={item} key={"Icon_"+index}/>
            )) 
            wpClass = ' col-12 col-md-8';
        }
        if(this.props.webPartProperties.type =='Links'){
            let isQuest = this.props.webPartProperties.ModText.length > 0 ? true : false; 
            selectedWP = <Links items={this.state.items} layout={this.state.webpartLayout} siteUrl={this.props.webPartProperties.site} isQuest={isQuest}/> 
        }
      
        return (
            <div className={'modWP'+this.props.webPartProperties.type+ wpClass+" "+this.state.webpartLayout}>
                {/* <div className="container"> */}
                    {/* <div className="row no-gutters">  */}
                    <h2>{this.state.webpartTitle}</h2>
                    <div className='row'>
                        {selectedWP}
                    </div> 
                {/* </div>  */}
            </div>
               /* </div> 
            </div>*/
        );
    }
}
export default ModWebParts;
